import { Pipe, PipeTransform } from '@angular/core';
import { formatDateTime, formatDateTimeFromLocal, formatDateTimeToLocal } from '@devwareapps/devware-cap';

@Pipe({
    name: 'wcDate'
})
/**
 * Temp pipe since these exists in the new Devware Feature Area branch as dwDate, but it's not ready yet
 */
export class WcDatePipe implements PipeTransform {

    transform(dateString: string, dateTimeOptions: { showTime: boolean, showAmPm: boolean, isGmt: boolean } = { showTime: true, showAmPm: true, isGmt: true}) {

        if (dateString) {
            if (dateTimeOptions?.isGmt) {
                return formatDateTimeToLocal(dateString, dateTimeOptions?.showTime, dateTimeOptions.showAmPm);
            }

            return formatDateTime(dateString, dateTimeOptions?.showTime, dateTimeOptions.showAmPm);
        }

        return '';
    }
}
